export default "## 查评论\n\n- 不一定会更新，如果aicu太久没更新的话本站再更新一次\n- 本站上次更新时间：2026.08.11\n- 偏向于v圈相关的动态，所以在其他动态下面评论不一定能被抓到\n- [点击前往](https://vtb.dog/replies)"